<script setup lang="ts">
defineProps<{
  items: {
    title: string
    type: string
    size: string | number
    url: string
  }[]
}>()
</script>

<template>
  <ul class="downloads cul">
    <li v-for="(item, index) in items" :key="index" v-animate="{ animation: 'vertical-reveal' }">
      <DownloadItem :item="item" />
    </li>
  </ul>
</template>
